import * as $ from 'jquery';
import 'bootstrap';
import { memberPortal } from "../member-portal";

export class memberIndex {
	private indxBody:any   = $('#members-index-body');
	private memberBase:any = new memberPortal();

	initProgressBarElem(): any {
		let _self = this;
		let inputElArr:any = $.makeArray(_self.indxBody.find('progress'));

		_self.memberBase.initProgressBarElem(inputElArr);
	}

	initCircularProgressBarElem(): any {
		let _self = this;		
		_self.memberBase.initCircularProgressBarElem();
	}

	initTables(): any {
		let _self = this;
		let paging = true;

		let recentActivityTable = $('#members--recent-activity table');
		_self.memberBase.initTables(recentActivityTable, paging);

		// sort table by first column, descending on load
		let recentActivityDataTable:any = $.fn.dataTable.Api(recentActivityTable);
		recentActivityDataTable.order( [ 0, 'desc' ] ).draw();
	}
}

let scope:Element = document.querySelector('#members-index-body');

if (scope) {
	try {
	let memberindex = new memberIndex();
	memberindex.initProgressBarElem();
	memberindex.initCircularProgressBarElem();
	memberindex.initTables();
	} catch(e) {console.error(e);}
}
